import type { MouseEvent } from "react";

/** Bouton info — ouvre le détail sans sélectionner la carte. */
export function CatalogInfoButton({
  label,
  onClick,
}: {
  label: string;
  onClick: (e: MouseEvent<HTMLButtonElement>) => void;
}) {
  return (
    <button
      type="button"
      className="pep-catalog-info-btn"
      aria-label={`En savoir plus — ${label}`}
      title="Voir le détail"
      onClick={(e) => {
        e.stopPropagation();
        onClick(e);
      }}
    >
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden>
        <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="1.75" />
        <path d="M12 11v5" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" />
        <circle cx="12" cy="8" r="1" fill="currentColor" />
      </svg>
    </button>
  );
}
